import DateRangePicker from './DateRangePicker';
import TimeRange from './TimeRange';
import SelectStudent from './SelectStudent';
import SelectTeacher from './SelectTeacher';
import SelectClass from './SelectClass';
import SelectClassroom from './SelectClassroom';
import DatePicker from './DatePicker';
import SimpleInput from './SimpleInput';
import Quantity from './Quantity';
import Money from './Money';
import TimePicker from './TimePicker';
import DropdownSelect from './DropdownSelect';
import Name from './Name';
import Input from './Input';
import Gender from './Gender';
import Tags from './Tags/index';
import Remarks from './Remarks';

export default {
  DateRangePicker,
  TimeRange,
  SelectStudent,
  SelectTeacher,
  SelectClass,
  SelectClassroom,
  DatePicker,
  SimpleInput,
  Quantity,
  Money,
  TimePicker,
  DropdownSelect,
  Name,
  Input,
  Gender,
  Tags,
  Remarks,
}



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/index.js